import React from 'react';
import { Check, Clock, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { STATUS_LABELS, STATUS_COLORS } from './SharedComponents';

export const CleanerView = ({ user, tasks, properties, onLogout, onUpdateTask }) => {
  const today = new Date().toISOString().split('T')[0];
  const sorted = [...tasks].sort((a, b) => a.date.localeCompare(b.date));
  const upcoming = sorted.filter(t => t.date >= today && t.status !== 'completata');
  const completed = sorted.filter(t => t.status === 'completata');

  return (
    <div className="min-h-screen bg-[#F7F9F9]" data-testid="cleaner-dashboard">
      <div className="bg-[#3e716c] text-white py-4 px-4">
        <div className="max-w-2xl mx-auto flex justify-between items-center">
          <div><h1 className="text-lg font-bold" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Le mie pulizie</h1><p className="text-xs text-white/70">{user.name}</p></div>
          <Button variant="ghost" onClick={onLogout} className="text-white hover:bg-white/20" data-testid="cleaner-logout-btn"><LogOut size={18} /></Button>
        </div>
      </div>
      <div className="max-w-2xl mx-auto px-4 py-6 space-y-6">
        {upcoming.length === 0 && completed.length === 0 && <p className="text-center text-[#0A1312]/40 py-12">Nessuna pulizia assegnata</p>}
        {upcoming.length > 0 && (
          <div>
            <h2 className="text-base font-bold text-[#0A1312] mb-3 flex items-center gap-2"><Clock size={16} className="text-[#65c3ba]" /> Da fare</h2>
            {upcoming.map(t => {
              const isToday = t.date === today;
              return (
                <div key={t.id} className={`bg-white border rounded-lg p-4 mb-3 ${isToday ? 'border-[#65c3ba] ring-1 ring-[#65c3ba]/30' : 'border-[#E2E8F0]'}`} data-testid={`cleaner-task-${t.id}`}>
                  <div className="flex justify-between items-start mb-2">
                    <div><p className="font-semibold text-[#0A1312]">{t.property}</p>{isToday && <span className="bg-[#65c3ba] text-white text-[10px] px-2 py-0.5 rounded-full">OGGI</span>}</div>
                    <span className={`px-2 py-1 rounded text-xs font-medium border ${STATUS_COLORS[t.status]}`}>{STATUS_LABELS[t.status]}</span>
                  </div>
                  <p className="text-sm text-[#0A1312]/70 mb-2">{t.date.split('-').reverse().join('/')}{t.time ? ` - ${t.time}` : ''}</p>
                  {t.notes && <p className="text-xs text-[#0A1312]/50 mb-3 bg-[#F7F9F9] p-2 rounded">{t.notes}</p>}
                  <div className="flex gap-2">
                    {t.status === 'assegnata' && <Button size="sm" className="bg-yellow-500 hover:bg-yellow-600 text-white text-xs" onClick={() => onUpdateTask(t.id, { status: 'in_corso' })}>Inizia pulizia</Button>}
                    {t.status === 'in_corso' && <Button size="sm" className="bg-emerald-500 hover:bg-emerald-600 text-white text-xs" onClick={() => onUpdateTask(t.id, { status: 'completata' })}><Check size={14} className="mr-1" />Completata</Button>}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {completed.length > 0 && (
          <div>
            <h2 className="text-base font-bold text-[#0A1312] mb-3"><Check size={16} className="inline text-emerald-500 mr-2" />Completate</h2>
            {completed.slice(0, 10).map(t => (
              <div key={t.id} className="bg-white/60 border border-[#E2E8F0] rounded-lg p-3 mb-2 opacity-70">
                <div className="flex justify-between items-center"><span className="text-sm">{t.property}</span><span className="text-xs text-[#0A1312]/40">{t.date.split('-').reverse().join('/')}</span></div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
